export default __webpack_public_path__ + "static/media/393.abfb0c07.jpg";